module.exports = __webpack_public_path__ + "img/75992.f069bf8c.svg";